import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import * as api from './api';
import AuthModal from './AuthModal';

function LoginPage({ onLogin, onClose }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const firstInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const { token } = await api.login(username, password, rememberMe);
      onLogin(token);
      navigate('/');
    } catch (err) {
      setError('Invalid username or password');
    }
  };

  return (
    <AuthModal title="Login" onClose={onClose} firstInputRef={firstInputRef} icon="login">
      <form onSubmit={handleSubmit} className="login-form">
        {error && <p className="error-message">{error}</p>}
        <input
          ref={firstInputRef}
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <div className="form-group checkbox-group">
          <label>
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
            />
            Keep me logged in
          </label>
        </div>
        <button title="Login" type="submit">Login</button>
      </form>
    </AuthModal>
  );
}

export default LoginPage;